import React from 'react';
import { useOutsideClick } from '../../../hooks/helpers/useOutsideClick';
import { Animation } from '../Animation';
import { useDrawer } from '../useDrawer';
import { DialogElement } from './Dialog.style';

interface DialogProps {
  children: React.ReactNode;
}

const Dialog = ({ children, ...props }: DialogProps): JSX.Element => {
  const ref = React.useRef<HTMLDivElement>(null);
  const { onClose } = useDrawer();
  useOutsideClick<HTMLElement>(ref, onClose);

  return (
    <Animation
      key="drawer"
      initial={{ translateX: '100%' }}
      animate={{ translateX: '0%' }}
      exit={{ translateX: '100%' }}
      transition={{ duration: 0.3 }}
    >
      <DialogElement ref={ref} {...props}>
        {children}
      </DialogElement>
    </Animation>
  );
};

export { Dialog };
